import {
  Create,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  BooleanInput,
  SelectArrayInput,
  FormDataConsumer,
  AutocompleteInput,
} from "react-admin";
import { statesList, roleOptions, privilegedRoleIds } from "../../../lib/constants";
import { Typography, Grid } from "@mui/material";
import { useAuth } from "../../../hooks/useAuth";

const AgencyInput = () => {
  return (
    <FormDataConsumer>
      {({ formData }) => {
        if (formData.role !== "agency") {
          return;
        }
        return (
          <>
            <ReferenceInput source="agency" reference="agency">
              <AutocompleteInput fullWidth optionText="name" />
            </ReferenceInput>
          </>
        );
      }}
    </FormDataConsumer>
  );
};

const NotificationControls = () => {
  return (
    <FormDataConsumer>
      {({ formData }) => {
        if (formData.role !== "admin") {
          return;
        }
        return (
          <>
            <BooleanInput
              label="Notify of new contract requests for all states"
              source="notifyAllContracts"
            />
            {!formData.notifyAllContracts && (
              <SelectArrayInput
                label="Notify of Contract Requests for these states"
                source="notifyContractStates"
                style={{ width: "90%" }}
                choices={statesList}
              />
            )}
            <BooleanInput
              label="Notify for new GA Contract requests"
              source="notifyGAContract"
            />
          </>
        );
      }}
    </FormDataConsumer>
  );
};

export const UserCreate = () => {
  const { user, isAgencyAdmin, isFullAdmin } = useAuth();
  const agencyAdmin = isAgencyAdmin(user);
  const fullAdmin = isFullAdmin(user);
  // Lite Admins (#73) may create users but only with non-privileged roles, and
  // cannot assign an agency or link an Agent record (those stay full-admin only).
  const roleChoices = fullAdmin
    ? roleOptions
    : roleOptions.filter((r) => !privilegedRoleIds.includes(r.id));

  return (
    <Create redirect="list">
      <SimpleForm>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextInput source="firstName" fullWidth />
              </Grid>
              <Grid item xs={6}>
                <TextInput source="lastName" fullWidth />
              </Grid>
              <Grid item xs={6}>
                <TextInput source="preferredName" fullWidth />
              </Grid>
              <Grid item xs={6}>
                <TextInput source="email" fullWidth />
              </Grid>
            </Grid>

            {!agencyAdmin && (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <SelectInput source="role" choices={roleChoices} />
                  </Grid>

                  {fullAdmin && (
                    <Grid item xs={6}>
                      <AgencyInput />
                    </Grid>
                  )}
                </Grid>
                <NotificationControls />
                {fullAdmin && (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <ReferenceInput source="agent" reference="agent">
                        <AutocompleteInput
                          fullWidth
                          label="Linked Agent (CRM)"
                          optionText={(r) =>
                            r?.id ? `${r.npn} — ${r.firstName || ""} ${r.lastName || ""}`.trim() : ""
                          }
                        />
                      </ReferenceInput>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </Grid>
          <Grid item xs={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6">Contact Information</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextInput source="address" fullWidth />
              </Grid>
              <Grid item xs={6}>
                <TextInput source="city" fullWidth />
              </Grid>
              <Grid item xs={6}>
                <SelectInput source="state" choices={statesList} />
              </Grid>
              <Grid item xs={6}>
                <TextInput source="zip" />
              </Grid>
              <Grid item xs={6}>
                <TextInput source="phone" fullWidth />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
export default UserCreate;
